import cx from 'classnames';
import React from 'react';

import { SpaceType } from '../../components/module/SpacingOptions';
import { Text } from '../../components/module/Text';
import { Wrapper } from '../../components/module/Wrapper';

export type ArticleProps = {
  theme?: {
    module?: {
      space?: SpaceType;
    };
  };
  content?: React.ReactElement;
};

export const Article = ({ theme, content }: ArticleProps) => {
  if (!content) return null;

  return (
    <Wrapper
      theme={{
        ...theme?.module,
        space: {
          top: theme?.module?.space?.top || 'xs',
          bottom: theme?.module?.space?.bottom,
        },
      }}
    >
      <div className="grid grid-cols-12">
        <div className="col-span-12 lg:col-span-8 lg:col-start-3 w-full">
          <Text
            background="white"
            className={cx(
              // reset prose width
              '[&_.prose]:max-w-none',
              // reset default media width
              '[&_.prose-media]:max-w-screen [&_.prose-media]:w-auto',
              // pull images out of 8/12 column
              // first one 100% container width
              'lg:[&_.prose-media:first-of-type_.image]:w-[calc(100%/8*12)]',
              'lg:[&_.prose-media:first-of-type_.image]:-translate-x-[calc(100%/12*2)]',
              // others slightly wider than 8 columns
              'lg:[&_.prose-media:not(:first-of-type)_.image]:w-[calc(100%/8*9)]',
              'lg:[&_.prose-media:not(:first-of-type)_.image]:-translate-x-[calc(100%/12*.66)]',
              // rounded corners on image
              '[&_.prose-media_.image]:overflow-hidden',
              '[&_.prose-media_.image]:rounded-3xl [&_.prose-media_.image]:md:rounded-4xl [&_.prose-media_.image]:lg:rounded-5xl',
            )}
          >
            {content}
          </Text>
        </div>
      </div>
    </Wrapper>
  );
};

export default React.memo(Article);
